"use strict";
// User Moderation Records Database Types
Object.defineProperty(exports, "__esModule", { value: true });
// NOTE (user-conduct-ledger spec, Phase 1): the filtered-violation-read types
// (`QueryUserViolationsParams` / `UserViolationsPage`) are deliberately NOT declared here. They are
// the signature of one `lambda-utilities` helper, named in a single file, so per the type-placement
// rule they live beside it as `// package-local` declarations. They graduate to `api/` in Phase 1
// task 1.2, when the HTTP route makes the response an actual cross-package API surface — at which
// point the audit's type-symbol denominator legitimately moves as part of an API change, rather than
// as a side effect of adding a util's parameter bag.
